module.exports = __webpack_public_path__ + "img/a1.dbe21d99.jpg";